import React, { ComponentProps } from "react";
import { ThemeVariant } from "../../utils/constants/generic-types";

interface GooglePayIconProps extends ComponentProps<"svg"> {
  variant?: ThemeVariant;
}

export default function GooglePayIcon({
  variant = ThemeVariant.DARK,
  ...props
}: GooglePayIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="20"
      viewBox="0 0 42 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3757_244273)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4878 15.3265V10.6138H22.92C23.9167 10.6138 24.758 10.2799 25.4438 9.62115L25.6083 9.45423C26.8611 8.0905 26.7788 5.96612 25.4438 4.70449C24.7762 4.0365 23.8619 3.67474 22.92 3.69331H19.0156V15.3265H20.4878ZM20.4879 9.18514V5.12194H22.9571C23.4876 5.12194 23.9906 5.32598 24.3656 5.6971C25.1612 6.47631 25.1795 7.77507 24.4113 8.58213C24.0363 8.98109 23.5059 9.2037 22.9571 9.18514H20.4879ZM32.4754 7.98848C31.8445 7.40403 30.985 7.10717 29.8969 7.10717C28.4979 7.10717 27.4463 7.62664 26.7513 8.65638L28.0498 9.482C28.5253 8.77697 29.1745 8.42449 29.9975 8.42449C30.5187 8.42449 31.0215 8.61933 31.4147 8.97181C31.7988 9.3058 32.0183 9.78815 32.0183 10.2984V10.6416C31.4513 10.3263 30.7381 10.1593 29.8603 10.1593C28.8362 10.1593 28.0132 10.4004 27.4006 10.8921C26.7879 11.3838 26.4771 12.0332 26.4771 12.8588C26.4588 13.6103 26.7788 14.3246 27.3458 14.8069C27.9218 15.3265 28.6533 15.5862 29.5128 15.5862C30.5278 15.5862 31.3324 15.1316 31.9451 14.2225H32.0091V15.3265H33.4173V10.419C33.4173 9.38926 33.1064 8.57292 32.4754 7.98848ZM28.4798 13.8607C28.178 13.638 27.9951 13.2763 27.9951 12.8867C27.9951 12.4506 28.1963 12.0888 28.5895 11.8012C28.9919 11.5136 29.4949 11.3652 30.0894 11.3652C30.9125 11.3559 31.5526 11.5415 32.0099 11.9125C32.0099 12.5434 31.763 13.0907 31.2783 13.5546C30.8393 13.9999 30.2449 14.2503 29.623 14.2503C29.2114 14.2596 28.809 14.1204 28.4798 13.8607ZM36.5811 18.8238L41.5005 7.3669H39.9003L37.6235 13.0814H37.5961L35.2644 7.3669H33.6642L36.892 14.8162L35.0632 18.8238H36.5811Z"
          fill={variant === ThemeVariant.DARK ? "#3C4043" : "white"}
        />
        <path
          d="M15.4043 9.59347C15.4043 9.13889 15.3677 8.68431 15.2947 8.23901H9.08594V10.8087H12.6429C12.4966 11.6344 12.0211 12.3765 11.3261 12.8403V14.5102H13.4476C14.6911 13.3506 15.4043 11.6344 15.4043 9.59347Z"
          fill="#4285F4"
        />
        <path
          d="M9.08659 16.1245C10.8605 16.1245 12.3601 15.5308 13.4482 14.5103L11.3269 12.8405C10.7325 13.2487 9.9736 13.4806 9.08659 13.4806C7.36757 13.4806 5.91367 12.3024 5.39248 10.7253H3.20703V12.4508C4.32265 14.7052 6.59944 16.1245 9.08659 16.1245Z"
          fill="#34A853"
        />
        <path
          d="M5.39219 10.7251C5.11787 9.89947 5.11787 8.99968 5.39219 8.1647V6.44849H3.20651C2.2645 8.33169 2.2645 10.5582 3.20651 12.4413L5.39219 10.7251Z"
          fill="#FBBC04"
        />
        <path
          d="M9.08659 5.40915C10.0284 5.39059 10.9337 5.75242 11.6103 6.41105L13.494 4.49999C12.2961 3.36823 10.7234 2.74673 9.08659 2.7653C6.59944 2.7653 4.32265 4.19393 3.20703 6.44818L5.39248 8.17367C5.91367 6.58733 7.36757 5.40915 9.08659 5.40915Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_3757_244273">
          <rect
            width="41"
            height="19"
            fill="white"
            transform="translate(0.5 0.529053)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
